/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   28/03/2022
 */

import { enAU, enUS, enGB, enCA, enIE, enIN, enNZ, fr, de, nl, ru, es, zhCN, pl, ptBR, ro, tr, sv, vi, ms } from "date-fns/locale";
import dateFnsFormat from "date-fns/format";
import {GridColTypeDef} from "@mui/x-data-grid";

const localeMap: Record<string, Locale> = {
	"en": enUS,
	"en-US": enUS,
	"en-GB": enGB,
	"en-AU": enAU,
	"en-CA": enCA,
	"en-IE": enIE,
	"en-NZ": enNZ,
	"zh-CN": zhCN,
	"pt_BR": ptBR,
	"en-IN": enIN,
	fr, de, nl, ru, es, pl, ro, tr, sv, vi, ms
};

// https://stackoverflow.com/a/57529410/288201
export const locale = localeMap[(new Intl.NumberFormat()).resolvedOptions().locale] || enUS;

export function format(date: any, formatStr = 'PP') {
	return date ? dateFnsFormat(date, formatStr, {locale}) : null;
}

export const dateTimeCol: GridColTypeDef = {
	headerName: "Created",
	type: "dateTime",
	width: 180,
	valueFormatter: (params) => {
		return format(params.value, 'P p');
	}
};

export function getOverlapInterval(interval1: Interval, interval2: Interval): Interval | null {
	const start = interval1.start > interval2.start ? interval1.start : interval2.start;
	const end = interval1.end < interval2.end ? interval1.end : interval2.end;

	return start < end ? { start, end } : null;
}
